import {Swiper, Pagination, Navigation, Autoplay} from 'swiper/dist/js/swiper.esm';
import mediumZoom from 'medium-zoom';

import {ScrollToElement} from './scroll-to';
import {Lazyloading} from './lazyloading';
import {SimplePopover} from './simple-popover';
import {RelatedProducts} from './wc-related';
import {SingleProduct} from './wc-single-product';
import {debounce} from './../helpers/debounce';

Swiper.use([Pagination, Navigation, Autoplay]);

let mediumZoomInstance = null;

const handleZoomableImages = () => {
  mediumZoomInstance = mediumZoom('[data-zoomable]');
};

const handleWindowScroll = (e) => {
  const $window = $(window);
  const $navMain = $('#navbar-main');

  if ($window.scrollTop() > 20) {
    if ($navMain.length > 0) {
      $navMain.addClass('navbar-main-fixed');
    }
  } else {
    if ($navMain.length > 0) {
      $navMain.removeClass('navbar-main-fixed')
    }
  }
  
}

$(function() {
  const scrollTo = new ScrollToElement();
  const lazyLoading = new Lazyloading();
  const simplePopover = new SimplePopover();
  const relatedProducts = new RelatedProducts();
  const singleProduct = new SingleProduct();

  // Init swiper intro
  const swiperIntro = new Swiper('.swiper-intro', {
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
    },
    pagination: {
      clickable: true,
      el: '.swiper-intro-pagination',
    },
    navigation: {
      nextEl: '.swiper-intro .swiper-button-next',
      prevEl: '.swiper-intro .swiper-button-prev',
    },
  });

  const swiperOurCostumers = new Swiper('.swiper-our-costumers', {
    slidesPerView: 3,
    spaceBetween: 20,
    autoplay: {
      delay: 4000,
    },
    navigation: {
      nextEl: '.swiper-our-costumers .swiper-button-next',
      prevEl: '.swiper-our-costumers .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      480: {
        slidesPerView: 1,
      },
    },
  });

  // Init gallery slider
  const swiperGallery = new Swiper('.js-swiper-gallery-1', {
    slidesPerView: 4,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.js-swiper-gallery-1 .swiper-button-next',
      prevEl: '.js-swiper-gallery-1 .swiper-button-prev',
    },
    on: {
      transitionEnd: () => {
        handleZoomableImages();
      },
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      480: {
        slidesPerView: 1,
      },
    },
  });

  // Init swiper our products
  const swiperOurProducts = new Swiper('.swiper-our-products', {
    slidesPerView: 3,
    spaceBetween: 15,
    autoplay: {
      delay: 4000,
    },
    navigation: {
      nextEl: '.swiper-our-products .swiper-button-next',
      prevEl: '.swiper-our-products .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: '.swiper-our-products .swiper-pagination',
          clickable: true,
          type: 'bullets',
        },
      },
      480: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-our-products .swiper-pagination',
          clickable: true,
          type: 'bullets',
        },
      },
    },
  });

  // -------------------------------------------------------------
  // scrollTo
  scrollTo.scrolltoGlobalElement();
  scrollTo.scrolltoTopElement();

  // -------------------------------------------------------------
  // lazyLoading
  lazyLoading.init();

  // Handle Window on scroll
  window.addEventListener('scroll', debounce(handleWindowScroll, 80));

  // ------------------------------
  // Simple popover
  simplePopover.init();

  // Related products
  relatedProducts.init();

  // Single Product
  singleProduct.init();

  handleZoomableImages();
});
